export const CUSTOMER_DELIVERY = {
  LIVE_IDENTITY_CHECK_CONSENT: 'live_identity_check_consent',
}
